import { BusinessPartnerClassification } from '@/lib/enums';
import { BUSINESS_PARTNER_LABELS, CUSTOMER_SUPPLIER_LABELS } from '@/lib/constants';

// Partner classification mapping
export const PARTNER_CLASSIFICATION_MAP: { [key: string]: number } = {
  得意先: BusinessPartnerClassification.CUSTOMER,
  仕入先: BusinessPartnerClassification.SUPPLIER,
  建設会社: BusinessPartnerClassification.CONSTRUCTION_COMPANY,
  見積会社: BusinessPartnerClassification.WITNESS_COMPANY,
};

// Helper functions
export const getPartnerClassification = (companyType: string): number => {
  return PARTNER_CLASSIFICATION_MAP[companyType] || BusinessPartnerClassification.CUSTOMER;
};

// Generate MenuItem options from enums and constants
export const getPartnerClassificationOptions = () => {
  return Object.entries(BUSINESS_PARTNER_LABELS).map(([key, label]) => ({
    value: Number.parseInt(key),
    label: label,
  }));
};

export const getCustomerCategoryOptions = () => {
  return Object.entries(CUSTOMER_SUPPLIER_LABELS).map(([key, label]) => ({
    value: Number.parseInt(key),
    label: label,
  }));
};
